import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class MyDocumentsService {

  baseUrl = environment.apiEnrolUrl;
  constructor(private storageService: StorageService, private http: HttpClient) { }

  getKycMedicalDocuments() {
    return this.http.get(this.baseUrl + '/truecover/get-kyc-medical-documents');
  }

  UploadKYCDocument(data): Observable<any> {
    return this.http.post(this.baseUrl + '/truecover/upload-other-document', data);
  }


  DeleteKycMedicalDocument(documentId: any): Observable<any> {

    const param = new HttpParams().set('docId', documentId);
    const httpOptions = {
      params: param
    };
    return this.http.get<any>(this.baseUrl + '/truecover/delete-kyc-medical-document', httpOptions);
  }

  getHealthCardDetails(familyMemberId: number): Observable<any> {

    const param = new HttpParams().set('memberId', String(familyMemberId));
    const httpOptions = {
      params: param
    };
    return this.http.get<any>(this.baseUrl + '/truecover/generate-id-card', httpOptions);
  }

  async getMembersOfHealthPolicies() {

    const userId = await this.storageService.get('userId');
    const param = new HttpParams().set('userId', userId);
    const httpOptions = {
      params: param
    };
    return this.http.get(this.baseUrl + '/truecover/get-all-family-members-in-health', httpOptions);
  }

  GetWholeDocumentsList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/truecover/documents');
  }
}
